// ========== [DISPARA ANIMAÇÃO] ==========
jQuery(document).ready(function ($) {
  let animou = false;

  function estatisticaAnimar() {
    const estatistica = $(".home-estatisticas")[0];
    if (estatistica) {
      const d_est = estatistica.offsetTop;
      const d_pag =
        window.pageYOffset + window.innerHeight - estatistica.offsetHeight - 80;

      // Animar
      if (!animou) {
        if (d_est - d_pag < 0) {
          console.log("Animação iniciada");
          $(".count").each(function () {
            const self = $(this);
            jQuery({ Counter: 0 }).animate(
              { Counter: self.text() },
              {
                duration: 2200,
                easing: "swing",
                step: function () {
                  self.text(Math.ceil(this.Counter));
                },
              }
            );
          });

          animou = true;
        }
      }
    }
  }

  setTimeout(() => {
    $(document).on("scroll", estatisticaAnimar);
  }, 1000);
});
